module.exports = __webpack_public_path__ + "static/img/bcg.6b42572e.jpg";